import { Field } from 'formik'

import TextBox from 'components/TextBox'

const MinMaxSettings = ({ id }) => {
  return (
    <section id={id}>
      <h3 id={id} className="header-title">
        Min/Max Per Order
      </h3>
      <div className="content-wrapper -more-space">
        <Field
          wrapperClassName="-space-right"
          component={TextBox}
          label="Minimum Quantity"
          name="minimumQuantity"
        />
        <Field
          component={TextBox}
          label="Maximum Quantity"
          name="maximumQuantity"
        />
      </div>
    </section>
  )
}

export default MinMaxSettings
